import * as type from "../types";
import {get, patch, put, deleteReq, post} from './../../config/Requests';
import {
    settingsContactDataRoute, settingsNotificationsRoute, settingsRemindersRoute,
    settingsOthersRoute, settingsMobileAppKeyRoute, settingsTiresChangeRoute,
    settingsRegularHolidaysRoute, settingsMovingHolidaysRoute, settingsDaysOffRoute,
    settingsWorkingHoursRoute, settingsImportDaysOffRoute, settingsPoiPointsRoute,
    commonReadGpsCoordsRoute, settingsImportPoiPointsRoute, settingsTrophyRoute, settingsExpectedCombustion,
    setingsDeleteAllPoi,
} from './../../config/routes';
import {openSnackbarInfoDispatch} from "./requestAction";
import {setData, setNotificationsData} from "../helpers";
import t from "../../languages/pl";

export const changeSaveReadiness = (name, value) => {
    return (dispatch, getState) => {
        let saveState = getState().settingsReducer.readyToSave;
        saveState = {
            ...saveState,
            [name]: value
        };
        dispatch({
            type: type.CHANGE_SAVE_READINESS,
            value: saveState
        });
    };
};

export const sendChangedData = (data) => {
    return (dispatch, getState) => {
        let saveState = getState().settingsReducer.readyToSave;
        if (saveState.defaultEmailsAndPhones)
            patchContactData(dispatch, data.defaultEmailsAndPhones);
        if (saveState.notifications)
            patchSettingsNotifications(dispatch, data.notifications);
        if (saveState.reminders)
            patchSettingsReminders(dispatch, data.reminders);
        if (saveState.otherSettings)
            patchOtherSettings(dispatch, data.otherSettings);
        if (saveState.tireChange)
            patchTireChange(dispatch, data.tireChange);
    };
};

export const getContactData = () => {
    return dispatch => {
        get(
            dispatch,
            settingsContactDataRoute,
            {},
            response => setData(dispatch, type.SET_DEFAULT_EMAILS_AND_PHONES, response)
        );
    };
};

const patchContactData = (dispatch, data) => {
    patch(
        dispatch,
        settingsContactDataRoute,
        {},
        data,
        () => {
            dispatch({
                type: type.SET_DEFAULT_EMAILS_AND_PHONES,
                value: data
            });
        }
    );
};

export const getSettingsNotifications = () => {
    return dispatch => {
        get(
            dispatch,
            settingsNotificationsRoute,
            {},
            response =>
                setNotificationsData(dispatch, type.SET_SETTINGS_NOTIFICATIONS, response)
        );
    };
};

const patchSettingsNotifications = (dispatch, data) => {
    patch(
        dispatch,
        settingsNotificationsRoute,
        {},
        data,
        () => {
            dispatch({
                type: type.SET_SETTINGS_NOTIFICATIONS,
                value: data
            });
        }
    );
};

export const getSettingsReminders = () => {
    return dispatch => {
        get(
            dispatch,
            settingsRemindersRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_REMINDERS, response)
        );
    };
};

const patchSettingsReminders = (dispatch, data) => {
    patch(
        dispatch,
        settingsRemindersRoute,
        {},
        data,
        () => {
            dispatch({
                type: type.SET_SETTINGS_REMINDERS,
                value: data
            });
        }
    );
};

export const getOtherSettings = () => {
    return dispatch => {
        get(
            dispatch,
            settingsOthersRoute,
            {},
            response => setData(dispatch, type.SET_OTHER_SETTINGS, response)
        );
    };
};

export const getTrophySettings = () => {
    return dispatch => {
        get(
            dispatch,
            settingsTrophyRoute,
            {},
            response => {
                dispatch({
                    type: type.SET_SETTINGS_TROPHY,
                    value: response.data
                });
            }
        );
    };
};

export const sendTrophySetting = (trophySettings) => {
    return dispatch => {
        const data = {trofea: trophySettings};
        post(
            dispatch,
            settingsTrophyRoute,
            data,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_TROPHY,
                    value: data
                });
            }
        );
    };
};

export const patchOtherSettings = (dispatch, data) => {
    patch(
        dispatch,
        settingsOthersRoute,
        {},
        data,
        () => {
            dispatch({
                type: type.SET_OTHER_SETTINGS,
                value: data
            });
        }
    );
};

export const getSettingsMobileAppKey = () => {
    return dispatch => {
        get(
            dispatch,
            settingsMobileAppKeyRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_MOBILE_APP_KEY, response)
        );
    };
};

export const putSettingsMobileKey = (groupId) => {
    let dto = {
        grupa_id: groupId,
        klucz: true
    };
    return dispatch => {
        put(
            dispatch,
            settingsMobileAppKeyRoute,
            null,
            dto,
            response => setData(dispatch, type.SET_SETTINGS_MOBILE_APP_KEY, response)
        );
    };
};

export const getTireChange = () => {
    return dispatch => {
        get(
            dispatch,
            settingsTiresChangeRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_TIRES_CHANGE, response)
        );
    };
};

const patchTireChange = (dispatch, data) => {
    put(
        dispatch,
        settingsTiresChangeRoute,
        null,
        data,
        () => {
            dispatch({
                type: type.SET_SETTINGS_TIRES_CHANGE,
                value: data
            });
        }
    );
};

export const getRegularHolidays = () => {
    return dispatch => {
        get(
            dispatch,
            settingsRegularHolidaysRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_REGULAR_HOLIDAYS, response)
        );
    };
};

export const putRegularHolidays = (data) => {
    return (dispatch, getState) => {
        const regularHolidays = getState().settingsReducer.regularHolidays;
        put(
            dispatch,
            settingsRegularHolidaysRoute,
            null,
            data,
            (response) => {
                const newMovingHoliday = {
                    ...response.data,
                    ...data,
                    data: data.data.toString(),

                };
                const updatedRegularHolidays = regularHolidays.concat(newMovingHoliday);
                dispatch({
                    type: type.SET_SETTINGS_REGULAR_HOLIDAYS,
                    value: updatedRegularHolidays
                });
                openSnackbarInfoDispatch(dispatch, t.regularHolidayHasBeenAdded);
            }
        );
    };
};

export const deleteRegularHoliday = id => {
    let idToDelete = {swieto_id: id};
    return (dispatch, getState) => {
        let holidays = getState().settingsReducer.regularHolidays;
        let newHolidays = holidays.filter(holiday => holiday.swieto_id !== id);
        deleteReq(
            dispatch,
            settingsRegularHolidaysRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_REGULAR_HOLIDAYS,
                    value: newHolidays
                });
                openSnackbarInfoDispatch(dispatch, t.regularHolidayHasBeenRemoved);
            }
        );
    };
};

export const getMovingHolidays = () => {
    return dispatch => {
        get(
            dispatch,
            settingsMovingHolidaysRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_MOVING_HOLIDAYS, response)
        );
    };
};

export const putMovingHolidays = (data) => {
    return (dispatch, getState) => {
        const movingHolidays = getState().settingsReducer.movingHolidays;
        put(
            dispatch,
            settingsMovingHolidaysRoute,
            null,
            data,
            (response) => {
                const newMovingHoliday = {
                    ...response.data,
                    ...data,
                    data: data.data.toString(),

                };
                const updatedMovingHolidays = movingHolidays.concat(newMovingHoliday);
                dispatch({
                    type: type.SET_SETTINGS_MOVING_HOLIDAYS,
                    value: updatedMovingHolidays
                });
                openSnackbarInfoDispatch(dispatch, t.movingHolidayHasBeenAdded);
            }
        );
    };
};

export const deleteMovingHoliday = id => {
    let idToDelete = {swieto_id: id};
    return (dispatch, getState) => {
        let holidays = getState().settingsReducer.movingHolidays;
        let newHolidays = holidays.filter(holiday => holiday.swieto_id !== id);
        deleteReq(
            dispatch,
            settingsMovingHolidaysRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_MOVING_HOLIDAYS,
                    value: newHolidays
                });
                openSnackbarInfoDispatch(dispatch, t.movingHolidayHasBeenRemoved);
            }
        );
    };
};

export const getDaysOff = () => {
    return dispatch => {
        getDaysOffReq(dispatch);
    };
};

const getDaysOffReq = dispatch => {
    get(
        dispatch,
        settingsDaysOffRoute,
        {},
        response => setData(dispatch, type.SET_SETTINGS_DAYS_OFF, response)
    );
};

export const putDaysOff = (data) => {
    return (dispatch, getState) => {
        const daysOff = getState().settingsReducer.daysOff;
        put(
            dispatch,
            settingsDaysOffRoute,
            null,
            data,
            response => {
                const updatedDaysOff = daysOff.concat(response.data);
                dispatch({
                    type: type.SET_SETTINGS_DAYS_OFF,
                    value: updatedDaysOff
                });
                openSnackbarInfoDispatch(dispatch, t.daysOffHasBeenAdded);
            }
        );
    };
};

export const deleteDayOff = id => {
    let idToDelete = {wolne_id: id};
    return (dispatch, getState) => {
        let daysOff = getState().settingsReducer.daysOff;
        let newDaysOff = daysOff.filter(holiday => holiday.wolne_id !== id);
        deleteReq(
            dispatch,
            settingsDaysOffRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_DAYS_OFF,
                    value: newDaysOff
                });
                openSnackbarInfoDispatch(dispatch, t.dayOffHasBeenRemoved);
            }
        );
    };
};

export const importDaysOffFromFile = data => {
    return (dispatch) => {
        let dto = data.map(element => ({
            auto_id: element.auto_id,
            opis: element.opis,
            data: element.data
        }));
        post(
            dispatch,
            settingsImportDaysOffRoute,
            dto,
            () => {
                getDaysOffReq(dispatch);
            }
        );
    };
};

export const getSettingsWorkingHours = () => {
    return dispatch => {
        get(
            dispatch,
            settingsWorkingHoursRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_WORKING_HOURS, response)
        );
    };
};

export const putSettingsWorkingHours = data => {
    return dispatch => {
        put(
            dispatch,
            settingsWorkingHoursRoute,
            null,
            data,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_WORKING_HOURS,
                    value: data
                });
            }
        );
    };
};

export const getPoiLocations = () => {
    return dispatch => {
        get(
            dispatch,
            settingsPoiPointsRoute,
            {},
            response => setData(dispatch, type.SET_SETTINGS_POI_POINTS, response)
        );
    };
};

export const getAddressForPoi = (address) => {
    return dispatch => {
        get(
            dispatch,
            commonReadGpsCoordsRoute,
            {adres: address},
            response => setData(dispatch, type.SET_SETTINGS_POI_COORDS, response)
        );
    };
};

export const changePoiCoords = (coords) => {
    return dispatch => {
        dispatch({
            type: type.SET_SETTINGS_POI_COORDS,
            value: coords
        });
    };
};

export const getPoiCoords = () => {
    return (dispatch, getState) => {
        const currentCoords = getState().settingsReducer.poiCoords;
        return currentCoords;
    };
};
export const addNewPoi = (data, poiLocation) => {
    const newPoi = {
        ...data,
        ...poiLocation
    };
    return (dispatch, getState) => {
        const poiList = getState().settingsReducer.poiLocations;
        post(
            dispatch,
            settingsPoiPointsRoute,
            newPoi,
            response => {
                const addedPoi = {
                    ...response.data,
                    adres: data.adres,
                    nazwa: data.nazwa,
                    punkt_gps: poiLocation,
                    typ: data.typ,
                };
                const newPoiList = [
                    ...poiList,
                    addedPoi
                ];
                dispatch({
                    type: type.SET_SETTINGS_POI_POINTS,
                    value: newPoiList
                });
                openSnackbarInfoDispatch(dispatch, t.poiHasBeenAdded);
            }
        );
    };
};

export const deletePoi = (id) => {
    let idToDelete = {poi_id: id};
    return (dispatch, getState) => {
        let poiLocationsList = getState().settingsReducer.poiLocations;
        let newPoiLocationsList = poiLocationsList.filter(location => location.poi_id !== id);
        deleteReq(
            dispatch,
            settingsPoiPointsRoute,
            idToDelete,
            () => {
                dispatch({
                    type: type.SET_SETTINGS_POI_POINTS,
                    value: newPoiLocationsList
                });
                openSnackbarInfoDispatch(dispatch, t.poiHasBeenRemoved);
            }
        );
    };
};

export const putPoi = (id, data, poiLocation) => {
    const updatedPoi = {
        ...data,
        ...poiLocation
    };
    const addedPoiToList = {
        poi_id: data.poi_id,
        adres: data.adres,
        nazwa: data.nazwa,
        punkt_gps: poiLocation,
        typ: data.typ,
    };
    return (dispatch) => {
        put(
            dispatch,
            settingsPoiPointsRoute,
            {poi_id: id},
            {...updatedPoi},
            () => {
                dispatch({
                    type: type.UPDATE_POI,
                    value: addedPoiToList
                });
                openSnackbarInfoDispatch(dispatch, t.poiHasBedUpdated);
            }
        );
    };
};

export const importPoi = (impoortedPoi) => {
    return (dispatch) => {
        post(
            dispatch,
            settingsImportPoiPointsRoute,
            impoortedPoi,
            () => {
                window.location.reload();
            }
        );
    };
};

export const deleteAllPoi = () => {
    return (dispatch) => {
        deleteReq(
            dispatch,
            setingsDeleteAllPoi,
            {},
            () => {
                dispatch({
                    type: type.SET_SETTINGS_POI_POINTS,
                    value: []
                });
                openSnackbarInfoDispatch(dispatch, t.allPoiHasBeenDeleted);
            }
        );
    };
};

export const postExpectedFuelConsumption = (data) => {
    return (dispatch) => {
        post(
            dispatch,
            settingsExpectedCombustion,
            data,
            () => {
                openSnackbarInfoDispatch(dispatch, t.expectedFuelConsumptionForSelectedCarsHasBeenUpdated);
            }
        );
    };
};